export default function WhyChooseUsSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      desc: '采用国际领先的加密技术，保障用户信息和资金安全，平台运营多年零安全事故',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24小时客服',
      desc: '专业客服团队全天候在线，随时解决您的问题，响应时间不超过3分钟',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端互通',
      desc: '支持PC端、手机端、平板等多设备无缝切换，随时随地畅享游戏乐趣',
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: '快速提现',
      desc: '多种提现方式可选，审核快速，最快5分钟到账，让您玩得放心',
    },
    {
      icon: 'ri-gamepad-line',
      title: '海量游戏',
      desc: '1000+款精品游戏，涵盖棋牌、电子、体育、捕鱼等多种品类，持续更新',
    },
    {
      icon: 'ri-medal-line',
      title: '品牌信誉',
      desc: '荣获多项行业大奖，5000万+用户的信赖之选，行业领军品牌',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            <a href="#why-us">为什么选择九游娱乐</a>
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            六大核心优势，为您提供极致的游戏娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="flex gap-4 p-5 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                <i className={`${feat.icon} text-primary-600 text-lg`}></i>
              </div>
              <div>
                <h3 className="text-base font-medium text-foreground-900 mb-1.5">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}